export default "__VITE_ASSET__BLH$hzwp__"